<div class="maps-panel" *ngIf="data">
  <div class="maps-panel__content">
    <div class="maps-panel__map" *ngIf="data.mapPicker" [innerHTML]="strHTML"></div>
  </div>
</div>
